import { mergeStyles, MessageBar, MessageBarType, ProgressIndicator, Spinner, Stack } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { popup } from '../../../addons/Popup';
import { useAppSelector } from '../../../App/store';
import { getAsync, postAsync } from '../../../utils/api';
import Form from './Form';
import Preview from './Preview';
import Verification from './Verification';

export type InvoiceData = {
  XMLDocumentId: string;
  PDFDocumentId: string;
  invoiceType: "EARSIV" | "EFATURA";
  recipientType: string;
  endpoint: string;
  created: number;
};

export default () => {
  const canUserCreateInvoices: boolean = useAppSelector(
    (state) => state.auth.userdata?.canCreateInvoice
  );
  const isAdmin: boolean = useAppSelector(
    (state) => state.auth.userdata?.admin
  );
  const [canCreateInvoices, setCanCreateInvoices] = useState<boolean>();
  const [canCreateThisInvoice, setCanCreateThisInvoice] = useState<boolean>();
  const [address, setAddress] = useState<any>();
  const [data, setData] = useState<InvoiceData>();
  const { formId } = useParams();

  useEffect(() => {
    getAsync("/invoices/is-active").then((res) => {
      setCanCreateInvoices(res.success && res.isActive === true);
    });
  }, []);

  useEffect(() => {
    getAsync("/invoices/can-invoice-form?formId=" + formId).then((res) => {
      setCanCreateThisInvoice(res.success && res.canInvoice === true);
    });
  }, []);

  useEffect(() => {
    if (!address) return;

    postAsync("/invoices/create", {
      address,
      formId,
    }).then((body) => {
      if (!body.success) {
        popup("Beklenmeyen bir hata oluştu. Hata Mesajı: " + body.message);
        return;
      }

      setData(body.data);
    });
  }, [address]);

  if (!formId) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>
        Link hatalı.
      </MessageBar>
    );
  }

  if (!canUserCreateInvoices) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>
        Fatura uygulaması entegrasyonu bulunmuyor.
      </MessageBar>
    );
  }

  if (canCreateInvoices === false && isAdmin !== true) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>
        Fatura uygulamasına bakım yapılıyor, şu anda fatura kesilemez.
      </MessageBar>
    );
  }

  if (canCreateThisInvoice === false) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>
        Bu form için EARSIV fatura oluşturulamaz.
      </MessageBar>
    );
  }

  if (canCreateInvoices === undefined || canCreateThisInvoice === undefined) {
    return <Spinner style={{ height: "80vh" }} />;
  }

  return address && !data ? (
    <>
      <ProgressIndicator className={removePaddingStyles} />
      <br />
      <Stack horizontalAlign="center">Fatura önizleme oluşturuluyor...</Stack>
    </>
  ) : (
    <Stack
      horizontal
      horizontalAlign="center"
      tokens={{ childrenGap: 15 }}
      style={{ width: "90%", marginLeft: "5%" }}
    >
      {address ? (
        <>
          <Verification formId={formId} data={data!} />
          <Preview formId={formId} PDFDocumentId={data!.PDFDocumentId} />
        </>
      ) : (
        <Form setAddress={setAddress} />
      )}
    </Stack>
  );
};

const removePaddingStyles = mergeStyles({
  padding: "0 !important",
  "& *": {
    padding: "0 !important",
  },
});
